/* src/app/vehicle/pages/vehicles-vor/vehicles-vor.component.scss */
.header {
  color: #00639c;
}
/*# sourceMappingURL=vehicles-vor.component.css.map */
